import { requiredString } from 'src/utils/schemas';
import * as Yup from 'yup';
import { transactionState } from './constants';

export const updateTransactionStateValidationSchema = Yup.object().shape({
	state: requiredString.oneOf(Object.values(transactionState), 'State must be valid transaction state'),
});
